import script from "./SearchResource.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResource.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__